import React, { useEffect, useRef } from 'react';
import { LineVertical } from '../icons/LineVertical';
import { LineHorizontal } from '../icons/LineHorizontal';
import CanvasImage from './CanvasImage';
import { Stage, Layer } from 'react-konva';
import { debounce } from 'debounce';
// Component for each product image
const PackagingCanvas = ({ side, settings, sideImage, uploadedImages, imageDimensions, canvasDimensions, customiserWidth, customiserHeight, canvasTop, canvasLeft, packagingHeight, packagingWidth, canvasRef, selectedImage, updateImageDimensions, updatePosition, setSelectedImage, calculateCanvasSize, }) => {
    const container = useRef(null);
    const checkDeselect = (e) => {
        // deselect when clicked on empty area
        const clickedOnEmpty = e.target === e.target.getStage();
        if (clickedOnEmpty) {
            setSelectedImage(side, null);
        }
    };
    useEffect(() => {
        const onWindowResize = debounce(() => {
            if (container.current) {
                calculateCanvasSize(side, container.current.getBoundingClientRect().width);
            }
        }, 500);
        window.addEventListener('resize', onWindowResize, false);
        if (container.current) {
            onWindowResize();
        }
    }, []);
    return (React.createElement("div", { className: `hg-modal__product-img ${side}` },
        React.createElement("div", { className: "hg-modal__line hg-modal__line--left" }, settings.hide_measurements ? null : (React.createElement(React.Fragment, null,
            React.createElement(LineVertical, null),
            React.createElement("p", null,
                packagingHeight,
                "mm")))),
        React.createElement("div", { className: "hg-modal__product-img--packaging", style: { '--side-width': customiserWidth, '--side-height': customiserHeight }, ref: container },
            React.createElement("img", { src: sideImage, alt: "", className: "" }),
            React.createElement(Stage, { className: "konva-stage", ref: canvasRef, width: canvasDimensions.width, height: canvasDimensions.height, style: { top: `${(canvasTop / customiserHeight) * 100}%`, left: `${(canvasLeft / customiserWidth) * 100}%`, border: '2px dashed #37404a' }, onMouseDown: checkDeselect, onTouchStart: checkDeselect },
                React.createElement(Layer, null, uploadedImages != null
                    ? uploadedImages.map((image, index) => (React.createElement(CanvasImage, { key: index, imageIndex: index, side: side, imageURL: image, imageDimensions: imageDimensions[index], updateImageDimensions: updateImageDimensions, updatePosition: updatePosition, isSelected: index === selectedImage, onSelect: () => {
                            setSelectedImage(side, index);
                        } })))
                    : null))),
        React.createElement("div", { className: "hg-modal__line hg-modal__line--bottom" }, settings.hide_measurements ? null : (React.createElement(React.Fragment, null,
            React.createElement(LineHorizontal, null),
            React.createElement("p", null,
                packagingWidth,
                "mm"))))));
};
export default PackagingCanvas;
